import 'css-chunksrc/client/scenes/projectStrategicAxes/projectStrategicAxesTable/projectStrategicAxisCreation/styles.scss';export default {
  "projectStrategicAxisCreation": "_projectStrategicAxisCreation_r30wy_1",
  "operator": "_operator_r30wy_11",
  "cell": "_cell_r30wy_15",
  "weight": "_weight_r30wy_21",
  "icon": "_icon_r30wy_27",
  "listRoot": "_listRoot_r30wy_31",
  "input": "_input_r30wy_39",
  "consistencyValueSelection": "_consistencyValueSelection_r30wy_56",
  "inputText": "_inputText_r30wy_60",
  "openedInput": "_openedInput_r30wy_67",
  "iconOpen": "_iconOpen_r30wy_73",
  "iconClose": "_iconClose_r30wy_82",
  "list": "_list_r30wy_31",
  "role": "_role_r30wy_97"
};